import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router';
import { connect } from 'react-redux';
import { keys, tryCatch, always } from 'ramda';
import { injectIntl, intlShape } from 'react-intl';

import { actions as viewActions } from 'store/viewstate';

import Toolbar from '../components/Toolbar';
import { MODULE_ACCESSOR, actions } from 'store/newDocumentStore';

const makeLocaleMessage = fm => (msg, values) =>
  tryCatch(fm, always('>> ERROR: no locale message provider <<'))({ id: msg }, { ...values });

const ToolbarContainer = ({ name, intl: { formatMessage }, ...other }) => (
  <Route
    path={`${DOCUMENTS_PATH}/:doc`}
    render={({ match, history }) => (
      <Toolbar
        name={name || match.params.doc || ''}
        navigate={path => history.push(path)}
        localeMessage={makeLocaleMessage(formatMessage)}
        {...other}
      />
    )}
  />
);

const mapStateToProps = state => {
  const sectionState = state.newDocs[MODULE_ACCESSOR];
  if (state.form && keys(state.form).length > 0) {
    const name = keys(state.form)[0];
    return { name, sectionState };
  }
  return { sectionState };
};

ToolbarContainer.propTypes = {
  sections: PropTypes.array.isRequired,
  userId: PropTypes.string,
  name: PropTypes.string,
  viewId: PropTypes.string,
  documents: PropTypes.array,
  isLoading: PropTypes.bool,
  intl: intlShape,
  editingDocument: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
};

export default connect(mapStateToProps, {
  cancel: actions.discardCommit,
  done: actions.finishCommit,
  clearViewId: viewActions.clearViewId,
})(injectIntl(ToolbarContainer));
